<template>
  <div class="definition">
    <div class="definition__info definition__info--leadership">
      <div class="info">
        <h1 class="info__title">Leadership</h1>

        <dots-number activeDots='5'/>

        <div class="info text-center">
          <div class="info__header">
            <p class="info__header-text">
              Leaders are ‘connective leaders’ and act as catalysts and conductors, facilitating
              connections and creating a diverse environment where people can be inspired and authentic,
              and where change and people can flourish.
            </p>
          </div>
          <div>
            <div class="info__body text-left">
              <p class="info__body-text font-weight-bold mb-4">
                Our assessment of Leadership examines the following attributes:
              </p>
              <ol>
                <li class="info__body-text"><b>Leaders as Catalysts</b>
                   – Every leader comes to expect and encourage change and the organisation
                   ensures there arechange-catalyst leaders among its ranks.</li>
                <li class="info__body-text"><b>Leaders as Coordinators</b>
                     – Leaders use their influence to coordinate, facilitate and enable
                     change throughout the whole organisation.</li>
                <li class="info__body-text"><b>Leaders as Conductors</b>
                 – Leaders are always making connections across the organisation and beyond,
                 and constantly working to bring the best out of their people.</li>
                <li class="info__body-text"><b>Leaders as Team Builders</b>
                   –  A positive team environment is nurtured and developed by leaders in the
                   organisation, with leaders seeing teamwork as vital to the organisation’s success.</li>
              </ol>
              <div class="info__footer pb-0">
              </div>
            </div>
          </div>
          <div class="info__footer pb-0">
            <slot></slot>
          </div>
        </div>
        <go-back-button/>
      </div>
    </div>
  </div>
</template>

<script>
// Components
import LeadershipInfo from '@/components/Evaluation/Leadership/Info';
import DotsNumber from '@/components/Evaluation/Dots';
import GoBackButton from '@/components/Helpers/GoBackButton';

export default {
  components: { LeadershipInfo, DotsNumber, GoBackButton },
  data() {
    return {
      id: 4,
    };
  },
};
</script>



// WEBPACK FOOTER //
// src/components/Definition/Leadership.vue